import React from "react";
import PropTypes from "prop-types";
const ChatBubble = props => {
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  const message = props.message.replace(urlRegex, function (url) {
    return "<a target=\"_blank\" onClick=\"ga('send', 'event', 'Tracking', 'link', 'FMP Chatbot Help');\" href=\"" + url + '">' + url + "</a>";
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "chat-bubble",
    dangerouslySetInnerHTML: {
      __html: message
    }
  });
};
ChatBubble.propTypes = {
  message: PropTypes.string
};
export default ChatBubble;